/**
 * The possible types of snackbar events
 */
export enum SnackbarEventType {
    // Displays informational text
    Informational = "Informational",
    // Displays an error
    Error = "Error",
    // Displays a successful message
    Success = "Success"
}